import { useJsApiLoader } from '@react-google-maps/api'

import { GOOGLE_API_KEY } from '@/constants/env'

const libraries = ['places' as const]

const useGoogleMapsScript = (apiKey: string = GOOGLE_API_KEY) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: apiKey,
    libraries
  })

  return { isLoaded, error: loadError } as const
}

export default useGoogleMapsScript
